module.exports = __webpack_public_path__ + "img/no_pic.2f64ed59.png";